const STORAGE_KEY = "userPreferences";

export const DEFAULT_USER_PREFERENCES = {
    platform: "facebook",
    language: "english",
    target: "",
};

function readAll() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
}

function writeAll(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function getUserPreferences(userId) {
    if (!userId) return { ...DEFAULT_USER_PREFERENCES };

    const all = readAll();
    return { ...DEFAULT_USER_PREFERENCES, ...all[userId] };
}

export function saveUserPreferences(userId, preferences) {
    if (!userId) return;

    const all = readAll();
    all[userId] = {
        ...DEFAULT_USER_PREFERENCES,
        ...all[userId],
        ...preferences,
    };
    writeAll(all);
}
